import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { theme } from '../theme';
import { BodyText, Label } from '../typography';

export const InfoRowLabel = styled(Label)`
  color: ${theme.colors.primaryK7};
  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h5-font-size);
  line-height: var(--h5-line-height);
  text-transform: uppercase;
  margin: 0;

  ${mediaQuery('md')} {
    margin: 0.325rem 0;
  }
`;

export const InfoRowText = styled(BodyText)`
  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  color: ${theme.colors.primaryK10};
  margin: 0;

  ${mediaQuery('md')} {
    margin: 0.325rem 0;
  }
`;

export const InfoRow = styled.div<{ accented?: boolean }>`
  width: 100%;
  display: grid;
  margin: 0.5rem 0;

  ${InfoRowLabel}, ${InfoRowText} {
    color: ${(props) => (props.accented ? theme.colors.primaryT1 : 'initial')};
    font-weight: ${(props) =>
      props.accented ? theme.fontWeight.bold : 'initial'};
  }

  ${mediaQuery('md')} {
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.2rem 0;
  }
`;
